import { JobInfo } from '../JobInfo/JobInfo'
import { useNavigate, useParams } from 'react-router-dom';
import { AuthContext, useAPI } from 'components/lib';
import { useContext, useEffect } from 'react';

export function JobInfoRouter(props) {
    const { job_id } = useParams()
    const { context } = useParams()
    const navigate = useNavigate();
    const authContext = useContext(AuthContext);
    const { data, loading } = useAPI(authContext?.user && '/api/hiring/profile');

    useEffect(() => {
        if (data) {
            if (data.createProfile) {
                navigate('/hiring/profile')
                return;
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data])

    if (!loading) {
        switch (context) {
            case "available":
                return (
                    <JobInfo
                        endpoint={`/api/hiring/job/posting/${job_id}`}
                    />
                );
            case "applied":
                return (
                    <JobInfo
                        endpoint={`/api/hiring/jobs/${job_id}/applied/details`}
                    />
                );
            case "view":
                if (authContext?.user) {
                    return (
                        navigate(`/hiring/jobs/${job_id}/available`)
                    );
                }
                
                return (
                    <JobInfo
                        endpoint={`/api/hiring/public/jobs/${job_id}`}
                    />
                );
            default:
                navigate('/notfound');
                break;
        }
    }

}